export const LOCALE_CONFIG = {
  panel: 'locale-config-panel',
  setupRequired: 'locale-config-setup-required',
  initialize: 'locale-config-initialize',
  catalogAdd: 'locale-config-catalog-add',
  catalogDialog: 'locale-config-catalog-dialog',
  languageRow: (code: string) => `locale-config-language-${code}`,
  makeDefault: (code: string) => `locale-config-make-default-${code}`,
  remove: (code: string) => `locale-config-remove-${code}`,
  authoring: {
    loading: 'locale-authoring-loading',
    error: 'locale-authoring-error',
    retry: 'locale-authoring-retry',
    profiles: {
      empty: 'locale-profiles-empty',
      add: 'locale-profiles-add',
      row: (id: string) => `locale-profile-${id}`,
      edit: (id: string) => `locale-profile-edit-${id}`,
      archive: (id: string) => `locale-profile-archive-${id}`,
    },
    glossaries: {
      empty: 'locale-glossaries-empty',
      add: 'locale-glossaries-add',
      row: (id: string) => `locale-glossary-${id}`,
      edit: (id: string) => `locale-glossary-edit-${id}`,
      archive: (id: string) => `locale-glossary-archive-${id}`,
    },
    profileDialog: 'locale-profile-dialog',
    glossaryDialog: 'locale-glossary-dialog',
  },
} as const;
